import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
// component
import { BalanceComponent as UserBalanceComponent } from './component/user/balance/balance.component';
import { FooterComponent } from './component/footer/footer.component';
import { HeaderComponent } from './component/header/header.component';
import { NavComponent } from './component/nav/nav.component';
import { SearchComponent as UserSearchComponent } from './component/user/search/search.component';
import { UserComponent } from './component/user/user.component';
import { UserComponent as FormSearchUserComponent } from './component/form/search/user/user.component';

// dialog
import { CommonComponent as DialogLedgerCommonComponent } from './dialog/ledger/common/common.component';
import { ConfirmComponent as DialogConfirmComponent } from './dialog/confirm/confirm.component';
import { DepositComponent as DialogLedgerDepositComponent } from './dialog/ledger/deposit/deposit.component';
import { NoticeComponent as DialogNoticeComponent } from './dialog/notice/notice.component';
import { PaymentComponent as DialogLedgerPaymentComponent } from './dialog/ledger/payment/payment.component';
import { RefundComponent as DialogLedgerRefundComponent } from './dialog/ledger/refund/refund.component';
import { RefundComponent as DialogLedgerRequestRefundComponent } from './dialog/ledger/request/refund/refund.component';
import { WithdrawalComponent as DialogLedgerRequestWithdrawalComponent } from './dialog/ledger/request/withdrawal/withdrawal.component';
import { WithdrawalComponent as DialogLedgerWithdrawalComponent } from './dialog/ledger/withdrawal/withdrawal.component';

// pipes
import { HumanCasePipe } from './pipe/human-case.pipe';

// providers
import { httpInterceptProviders } from './service/http-intercept.service';

// views
import { FeesComponent as ViewFeesComponent } from './view/fees/fees.component';
import { HistoryComponent as ViewHistoryComponent } from './view/history/history.component';
import { ConfigComponent as ViewConfigComponent } from './view/config/config.component';
import { ImportComponent as ViewOperatorImportComponent } from './view/users/import/import.component';
import { IndexComponent as ViewIndexComponent } from './view/index/index.component';
import { LoginComponent as ViewLoginComponent } from './view/login/login.component';
import { RefundComponent as ViewTransactionRefundComponent } from './view/transaction/refund/refund.component';
import { SubscriptionsComponent as ViewSubscriptionsComponent } from './view/subscriptions/subscriptions.component';
import { TokenComponent as ViewLoginTokenComponent } from './view/login/token/token.component';
import { TransactionComponent as ViewTransactionComponent } from './view/transaction/transaction.component';
import { UsersComponent as ViewUsersComponent } from './view/users/users.component';

import { ConfirmComponent } from './dialog/confirm/confirm.component';
import { DateDatePipe } from './pipe/date-date-pipe';
import { DateDateTimePipe } from './pipe/date-date-time-pipe';
import { PlansComponent } from './view/subscriptions/plans/plans.component';
import { DetailComponent } from './view/subscriptions/plans/detail/detail.component';
import { TiersComponent } from './view/subscriptions/plans/tiers/tiers.component';
import { TierComponent } from './view/subscriptions/plans/tiers/tier/tier.component';
import { ClipboardComponent } from './component/clipboard/clipboard.component';

// sort

@NgModule({
    declarations: [
        AppComponent,
        DateDatePipe,
        DateDateTimePipe,
        DialogConfirmComponent,
        DialogLedgerCommonComponent,
        DialogLedgerDepositComponent,
        DialogLedgerRefundComponent,
        DialogLedgerPaymentComponent,
        DialogLedgerRequestRefundComponent,
        DialogLedgerRequestWithdrawalComponent,
        DialogLedgerWithdrawalComponent,
        DialogNoticeComponent,
        FooterComponent,
        FormSearchUserComponent,
        HeaderComponent,
        HumanCasePipe,
        ViewConfigComponent,
        ViewFeesComponent,
        ViewHistoryComponent,
        ViewIndexComponent,
        ViewLoginComponent,
        ViewLoginTokenComponent,
        ViewOperatorImportComponent,
        ViewSubscriptionsComponent,
        ViewTransactionComponent,
        ViewTransactionRefundComponent,
        ViewUsersComponent,
        UserComponent,
        UserBalanceComponent,
        UserSearchComponent,
        NavComponent,
        ConfirmComponent,
        PlansComponent,
        DetailComponent,
        TiersComponent,
        TierComponent,
        ClipboardComponent,
    ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        ClipboardModule,
        FormsModule,
        HttpClientModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatDialogModule,
        MatMenuModule,
        MatPaginatorModule,
        MatTableModule,
        ReactiveFormsModule,
    ],
    providers: [httpInterceptProviders],
    bootstrap: [AppComponent],
})
export class AppModule {}
